import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const WHO_DATA = DATA.who;

const Who = () => {
    
    return (
        <section id='who-id' className="container">
            <div className="who-block">
                <p className="title">{WHO_DATA.title}</p>
                <div className="content">
                    {WHO_DATA.content.map((item, index) => {
                        return (
                            <div className="item-border" key={index}>
                                <div className="item">
                                    <p className="item__index">0{index + 1}.</p>
                                    <p className="item__text" dangerouslySetInnerHTML={{__html: item}}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default Who